<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: '修理代金サポートサービス',
      titleTemplate: '%s | auスマートパス',
      htmlAttrs: {
        lang: 'ja',
      }
    }
  }
</script>

<style>
#app {
  height: 100%;
}
</style>
